const original = asset => `/qolak/pastel/images/${asset}.webp`;
const variant = (asset, size) => `/qolak/pastel/optimized-v1/${asset}-${size}.webp ${size}w`;

export const illustrationSizes = '(max-width: 760px) 90vw, (max-width: 1200px) 45vw, 600px';

export function illustrationSources(asset) {
  return [variant(asset, 480), variant(asset, 960), `${original(asset)} 1254w`].join(', ');
}

export function goalThumbnailSources(asset) {
  return [variant(asset, 128), variant(asset, 256)].join(', ');
}
